var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            "custom-class": "",
            "close-on-click-modal": false,
            visible: _vm.innerVisible,
            title: _vm.title,
            "show-close": false,
            width: "700px"
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            },
            close: _vm.cancel
          }
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                "label-position": "left",
                "label-width": "70px",
                model: _vm.modifyCharge,
                inline: true
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("Billing.billingCharge_chargeItem") }
                },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "150px" },
                    attrs: {
                      filterable: "",
                      no: "1",
                      "select-type": _vm.selectTypeNames.basic_data_ChargeItem,
                      "default-value": _vm.modifyCharge.chargeChargeItemId,
                      "callback-method-type": "value",
                      disabled: !_vm.isEditing || _vm.operateType === 2,
                      "tag-name": "zhName"
                    },
                    on: {
                      parentCallBack: function(value) {
                        return (_vm.modifyCharge.chargeChargeItemId = Number(
                          value
                        ))
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.AuditDate") } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      no: "2",
                      placeholder: _vm.$t("Message.SelectDate"),
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      "default-value": _vm.modifyCharge.chargeAuditDate
                    },
                    model: {
                      value: _vm.modifyCharge.chargeAuditDate,
                      callback: function($$v) {
                        _vm.$set(_vm.modifyCharge, "chargeAuditDate", $$v)
                      },
                      expression: "modifyCharge.chargeAuditDate"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("Billing.billingJob_settleAccountsTo")
                  }
                },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "300px" },
                    attrs: {
                      filterable: "",
                      no: "3",
                      "select-type": _vm.selectTypeNames.basic_data_Company,
                      "callback-method-type": "value",
                      "default-value": _vm.modifyCharge.chargeAccountId,
                      "tag-name": "chineseName",
                      disabled: true
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.ContactPerson") } },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "130px" },
                    attrs: {
                      no: "4",
                      "select-type": _vm.selectTypeNames.static_data_Contact,
                      filterable: "",
                      cache: false,
                      disabled: !_vm.isEditing || _vm.operateType === 2,
                      "default-value": _vm.modifyCharge.chargeContactPerson,
                      "static-options": _vm.contactArray
                    },
                    on: {
                      parentCallBack: function(item) {
                        return (_vm.modifyCharge.chargeContactPerson =
                          item.value)
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Billing.billingCharge_currency") } },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "175px" },
                    attrs: {
                      filterable: "",
                      no: "5",
                      clearable: false,
                      "select-type": _vm.selectTypeNames.basic_data_Currency,
                      "default-value": _vm.modifyCharge.chargeCurrency,
                      disabled: !_vm.isEditing || _vm.operateType === 2
                    },
                    on: {
                      parentCallBack: function(item) {
                        _vm.modifyCharge.chargeCurrency = item.value
                        _vm.amountChangeHandler()
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("Billing.billingCharge_taxExcludedPrice")
                  }
                },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "100px" },
                    attrs: {
                      no: "6",
                      controls: false,
                      min: 0,
                      disabled: !_vm.isEditing || _vm.operateType === 2
                    },
                    on: { change: _vm.excludingTaxAmountChangeHandler },
                    model: {
                      value: _vm.modifyCharge.chargeExcludingTaxAmount,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.modifyCharge,
                          "chargeExcludingTaxAmount",
                          $$v
                        )
                      },
                      expression: "modifyCharge.chargeExcludingTaxAmount"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("Billing.billingCharge_taxIncludedPrice")
                  }
                },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "100px" },
                    attrs: {
                      no: "7",
                      controls: false,
                      min: 0,
                      disabled: !_vm.isEditing || _vm.operateType === 2
                    },
                    on: {
                      change: function($event) {
                        return _vm.amountChangeHandler()
                      }
                    },
                    model: {
                      value: _vm.modifyCharge.chargeAmount,
                      callback: function($$v) {
                        _vm.$set(_vm.modifyCharge, "chargeAmount", $$v)
                      },
                      expression: "modifyCharge.chargeAmount"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Billing.billingCharge_taxAmount") } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "80px" },
                    attrs: { no: "8", controls: false, disabled: true },
                    model: {
                      value: _vm.modifyCharge.chargeTaxAmount,
                      callback: function($$v) {
                        _vm.$set(_vm.modifyCharge, "chargeTaxAmount", $$v)
                      },
                      expression: "modifyCharge.chargeTaxAmount"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.TaxRate") } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "80px" },
                    attrs: {
                      no: "9",
                      controls: false,
                      disabled: !_vm.isEditing || _vm.operateType === 2
                    },
                    on: { change: _vm.excludingTaxAmountChangeHandler },
                    model: {
                      value: _vm.modifyCharge.chargeTaxRate,
                      callback: function($$v) {
                        _vm.$set(_vm.modifyCharge, "chargeTaxRate", $$v)
                      },
                      expression: "modifyCharge.chargeTaxRate"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Quantity2") } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "80px" },
                    attrs: {
                      no: "chargeQuantity",
                      precision: 3,
                      controls: false,
                      disabled: !_vm.isEditing || _vm.operateType === 2
                    },
                    on: { change: _vm.quantityChangeHandler },
                    model: {
                      value: _vm.modifyCharge.chargeQuantity,
                      callback: function($$v) {
                        _vm.$set(_vm.modifyCharge, "chargeQuantity", $$v)
                      },
                      expression: "modifyCharge.chargeQuantity"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.UnitRate") } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "80px" },
                    attrs: {
                      no: "chargeUnitRate",
                      precision: 3,
                      controls: false,
                      disabled: !_vm.isEditing || _vm.operateType === 2
                    },
                    on: { change: _vm.unitRateChangeHandler },
                    model: {
                      value: _vm.modifyCharge.chargeUnitRate,
                      callback: function($$v) {
                        _vm.$set(_vm.modifyCharge, "chargeUnitRate", $$v)
                      },
                      expression: "modifyCharge.chargeUnitRate"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Billing.billingCharge_remarks") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "500px" },
                    attrs: { no: "10", type: "textarea", rows: 5 },
                    model: {
                      value: _vm.chargeRemarks,
                      callback: function($$v) {
                        _vm.chargeRemarks = $$v
                      },
                      expression: "chargeRemarks"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "11", size: "mini" },
                  on: { click: _vm.saveEvent }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "12", size: "mini" },
                  on: { click: _vm.cancel }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }